export const OFFERS_PARAMS = {
    viewRules: 'role_user',
    fields: 'name,iframe_supported,type_id,creative_placement',
    typeId: '1,2,6,7',
    limit: 300,
};

export const PLACEMENTS_PARAMS = {
    fields: 'id,url,offer_id',
    statuses: 'allow',
    limit: 50,
};

export const ORD_FORM_TYPES = {
    textGraphic: 'textGraphic',
    text: 'text',
    banner: 'banner',
};

export const ORD_FORM_OPTIONS = (
    t: (phrase: string) => string,
): {
    label: string;
    value: string;
}[] => [
    { label: t('TextGraphic'), value: ORD_FORM_TYPES.textGraphic },
    { label: t('Text block'), value: ORD_FORM_TYPES.text },
    { label: t('Banner'), value: ORD_FORM_TYPES.banner },
];

export const INITIAL_CREATIVE = {
    code: '',
    erid: '',
    ordFullData: '',
    link: '',
    subIds: {},
};
